import { Id } from "@dhx/ts-common/types";
import { DataCollection, DataEvents, IDataItem, Statuses } from "@dhx/ts-data";

interface IState {
	time: Date;
	state: IDataItem[];
}

interface IHistoryManager {
	saveDelay: number;
	disabled: boolean;

	add(newState: IDataItem[]): void;
	reset(): void;
	undo(first?: boolean): void;
	redo(): void;
	isUndo(): boolean;
	isRedo(): boolean;
	enable(): void;
	disable(): void;
}

export class HistoryManager implements IHistoryManager {
	public saveDelay = 500;
	public disabled = false;

	private _data: DataCollection;
	private _state: IState[];
	private _position: number;
	private _inProgress: boolean;

	constructor(data: DataCollection) {
		this._data = data;
		this.reset();
		this._data.events.on(DataEvents.change, (_id: Id, status: Statuses) => {
			if (!this._inProgress && status && !this.disabled) {
				this.add(this._data.serialize());
			}
		});
	}
	enable(): void {
		this.reset();
		this.disabled = false;
	}
	disable(): void {
		this.disabled = true;
	}
	add(newState: IDataItem[]): void {
		if (this.disabled) {
			return;
		}
		if (this._position !== this._state.length - 1) {
			this._state = this._state.slice(0, this._position + 1);
		}

		const last = this._state.length - 1;
		const now = new Date();
		const obj = {
			time: now,
			state: newState,
		};

		if (now.valueOf() - this._state[last].time.valueOf() > this.saveDelay) {
			this._state.push(obj);
			this._position++;
		} else {
			this._state[last] = obj;
		}
	}
	reset(): void {
		if (!this._inProgress) {
			this._state = [{ time: new Date(), state: this._data.serialize() }];
			this._position = 0;
		}
	}
	undo(first?: boolean): void {
		if (this.isUndo() && !this.disabled) {
			if (first) {
				this._position = 0;
				this._state = this._state.slice(0, 1);
			} else {
				this._position--;
			}
			this._apply(this._state[this._position]);
		}
	}
	redo(): void {
		if (this.isRedo() && !this.disabled) {
			this._position++;
			this._apply(this._state[this._position]);
		}
	}
	isUndo(): boolean {
		return this._position > 0;
	}
	isRedo(): boolean {
		return this._position + 1 <= this._state.length - 1;
	}
	private _apply(state): void {
		this._inProgress = true;
		this._data.parse(JSON.parse(JSON.stringify(state.state)));
		this._inProgress = false;
	}
}
